import {useEffect, useRef, useState} from 'react';

// http://upshots.org/actionscript/jsas-understanding-easing
/*
    @t is the current time (or position) of the tween. This can be seconds or frames, steps, seconds, ms, whatever
        – as long as the unit is the same as is used for the total time [3].
    @b is the beginning value of the property.
    @c is the change between the beginning and destination value of the property.
    @d is the total time of the tween.
*/
export function easeInOutQuad(t, b, c, d) {
    return (t /= d / 2) < 1?
        c / 2 * t * t + b :
        -c / 2 * ((--t) * (t - 2) - 1) + b;
}

export function easeOutQuad(t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
}

export function easeInQuad(t, b, c, d) {
    return c * (t /= d) * t + b;
}

const tStep = 1000 / 20;
const raf = typeof window !== 'undefined' && window.requestAnimationFrame || (func => setTimeout(func, tStep));
export const caf = typeof window !== 'undefined' && window.cancelAnimationFrame || clearTimeout;

export function ease({start, end, msDur, fEase, onStep, onComplete}) {
    const oEase = {tAbs: new Date().getTime()};

    function step() {
        oEase.timer = undefined;
        const t = new Date().getTime() - oEase.tAbs;
        if (t < msDur) {
            onStep(fEase(t, start, end - start, msDur));
            oEase.timer = raf(step);
        } else {
            onStep(end);
            onComplete && onComplete();
        }
    }
    oEase.timer = raf(step);
    return oEase;
}
